import PropTypes from "prop-types"
import React, { useState } from "react"
import styled, { css } from "styled-components"

//------------------------------------------------------------------------------

function AppInput(props) {
    const {
        className,
        label,
        hiddenText,
        value,
        validationMessage,
        disabled,
        required,
        placeholder,
        type,
        id,
    } = props
    const [focused, setIsFocused] = useState("")

    // -------------------------------------

    function onChange(event) {
        const { onChange } = props

        onChange(event)
    }

    function onBlur(event) {
        const { onBlur } = props

        setIsFocused(false)
        onBlur(event)
    }

    function handleFocus() {
        setIsFocused(true)
    }

    function getStateClass() {
        let cssClass = ""
        if (focused) {
            cssClass = "focused"
        } else {
            cssClass = value ? "valid" : ""
        }

        return cssClass
    }

    // -------------------------------------

    return (
        <div className={`${className} ${getStateClass()} app-input`} id={id}>
            <label className="input-label">{label}</label>
            <input
                type={type || (hiddenText && "password") || "text"}
                value={value || ""}
                className="tm4-input"
                onChange={onChange}
                onBlur={onBlur}
                onFocus={handleFocus}
                required={required}
                disabled={disabled}
                autoComplete="off"
                placeholder={placeholder}
            />

            {validationMessage && (
                <span className="validation-error-message">
                    {validationMessage}
                </span>
            )}
        </div>
    )
}

// ----------------------------------------------------------------------------
// Component PropTypes and default props
// ----------------------------------------------------------------------------

AppInput.propTypes = {
    className: PropTypes.string.isRequired,
    label: PropTypes.string,
    hiddenText: PropTypes.bool,
    value: PropTypes.any,
    onChange: PropTypes.func,
    onBlur: PropTypes.func,
    validationMessage: PropTypes.string,
    disabled: PropTypes.bool,
    required: PropTypes.bool,
    placeholder: PropTypes.string,
    type: PropTypes.string,
    id: PropTypes.string,
}

AppInput.defaultProps = {
    onChange: () => {},
    onBlur: () => {},
    validationMessage: null,
    disabled: false,
}

// ----------------------------------------------------------------------------

const StyledAppInput = styled(AppInput)`
    & {
        position: relative;

        display: flex;
        flex-direction: column;
        border-radius: 6px;

        font-size: 14px;
        max-width: 100%;
        width: 100%;
        background-color: transparent;

        overflow: hidden;

        ${(props) =>
            props.disabled &&
            css`
                cursor: not-allowed;
            `}

        .tm4-input {
            flex: 1;
            z-index: 2;
            border: 1px solid ${(props) => props.theme.colors.inputBorder};

            font-family: "Poppins-Regular";
            border-radius: 6px;
            min-height: 50px;
            height: 50px;
            max-height: 50px;
            background-color: transparent;
            font-size: 14px;
            padding-left: 10px;
            color: ${(props) => props.theme.colors.textPrimary};

            ::-webkit-inner-spin-button,
            ::-webkit-outer-spin-button {
                display: none;
                -webkit-appearance: none;
                margin: 0;
            }

            :focus {
                outline: none;
                border-color: ${(props) =>
                    props.theme.colors.primaryColor} !important;
            }

            :focus,
            :valid {
                /* padding-top: 8px; */
            }
        }

        .input-label {
            font-size: 14px;
            font-family: "Poppins-Bold";
            text-transform: uppercase;
            position: relative;
            bottom: 3px;

            user-select: none;

            ${(props) =>
                props.disabled &&
                css`
                    z-index: 1;
                    color: #d6d6d6;
                    cursor: not-allowed;
                `}
        }

        .validation-error-message {
            position: absolute;
            top: 50%;
            left: 102%;
            width: 50%;
            transform: translateY(-50%);
            font-size: 10px;
            font-weight: 600;
            color: rgb(255, 59, 48);
        }

        /* MOBILE */
        @media (max-width: ${(props) => props.theme.screenSizes.mobile}px) {
            .validation-error-message {
                position: absolute;
                top: 101%;
                left: 10px;
                width: 100%;
                transform: unset;
                line-height: 1;
            }
        }
    }

    &.focused {
        /* .input-label {
      position: absolute;
      top: 8.5px;
      font-size: 10px;
      font-weight: 600;
      color: ${(props) => props.theme.colors.primaryColor};
    } */
    }

    &.valid {
        /* .input-label {
      position: absolute;
      top: 8.5px;
      font-size: 10px;
      font-weight: 600;
    } */
    }
`
// ----------------------------------------------------------------------------

export default StyledAppInput
